import { lazy } from 'react';

export const RETRY_DELAYS_MS = [250, 1000];

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const importWithRetry = async <T>(importChunk: () => Promise<T>): Promise<T> => {
  for (const delay of RETRY_DELAYS_MS) {
    try {
      return await importChunk();
    } catch {
      await wait(delay);
    }
  }

  return importChunk();
};

/**
 * A rejected chunk request has no boundary between it and the root, so React unmounts
 * the whole tree and the user is left staring at a blank page. Retrying covers the
 * transient failures (dropped connections, and hashed assets that briefly 404 while a
 * deploy rolls out) that make up nearly all of them.
 */
const lazyWithRetry: typeof lazy = (importChunk) => lazy(() => importWithRetry(importChunk));

export default lazyWithRetry;
